// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"03f7dd74","19":"bfbc44d6","57":"0410040a","156":"1793603c","319":"053fc9fa","429":"a8a6ccfa","804":"c5cebe69","946":"cf3070f2","949":"9e9d3bb8"}[chunkId] + ".chunk.js";
};